export function isChromatic() {
  return document.body.classList.contains('isChromatic');
}
